// extracted by mini-css-extract-plugin
module.exports = {"activeLink":"Tabs_activeLink__ZBPQ2","wrapper":"Tabs_wrapper__TCUhT","navContainer":"Tabs_navContainer__4phAc","tab":"Tabs_tab__6936A"};